<ng-container *ngIf="isVisible || outOfViewportHeight === undefined; else templatePlaceholder">
    <ng-template #templateTitle><ng-content select="f-facet[name=title],[facet-title]"></ng-content></ng-template>
    <ng-template #templateInfo><ng-content select="f-facet[name=info],[facet-info]"></ng-content></ng-template>

    <!-- section content -->
    <ng-template #templateFolded><ng-content select="f-facet[name=section-folded],[facet-section-folded]"
            description="Provide folded section content, use w-slot components to create columns"></ng-content></ng-template>
    <ng-template #templateUnfolded><ng-content select="f-facet[name=section-unfolded],[facet-section-unfolded]"
            description="Provide unfolded section content, use w-slot components to create columns"></ng-content></ng-template>

    <!-- w-section -->
    <ng-template #templateFoldedSection><ng-content select="w-section[facet-folded]"
            description="Provide folded w-section component"></ng-content></ng-template>
    <ng-template #templateUnfoldedSection><ng-content select="w-section[facet-unfolded]"
            description="Provide unfolded w-section component"></ng-content></ng-template>

    <!-- footer -->
    <ng-template #templateFoldedFooter><ng-content select="f-facet[name=footer-folded],[facet-footer-folded]"
            description="Folded footer content"></ng-content></ng-template>
    <ng-template #templateUnfoldedFooter><ng-content select="f-facet[name=footer-unfolded],[facet-footer-unfolded]"
            description="Unfolded footer content"></ng-content></ng-template>

    <!-- actions -->
    <ng-template #templateSecondaryActions><ng-content
            select="[facet-secondary-actions],f-facet[name=secondary-actions]"
            description="use text button or size=medium icon buttons"></ng-content></ng-template>
    <ng-template #templatePrimaryAction><ng-content select="[facet-primary-action],f-facet[name=primary-action]"
            description="use text button or size=medium icon button"></ng-content></ng-template>
    <ng-template #templateFreeAction><ng-content select="[facet-free-action],f-facet[name=free-action]"
            description="use a regular text button"></ng-content></ng-template>
</ng-container>
<!-- placeholder -->
<ng-template #templatePlaceholder><ng-content select="[facet-placeholder]"></ng-content></ng-template>